import { createFileRoute } from '@tanstack/react-router'
import WatchlistsPage from '@features/watchlists/components/WatchlistsPage'
import { AutoBreadcrumb } from '@/components/ui/auto-breadcrumb'

export const Route = createFileRoute('/_authenticated/watchlists')({
  component: WatchlistsPageRoute,
})

function WatchlistsPageRoute() {
  return (
    <div className="p-3 md:p-6 space-y-2 md:space-y-3">
      <div className="-mb-1 md:-mb-2">
        <AutoBreadcrumb />
      </div>
      <WatchlistsPage />
    </div>
  )
}
